import axios from "axios";
import { environment } from "../../../environment";
export const url = (accountGroupId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/account-groups/v4/account-groups/${accountGroupId}`
        : `https://middleware.uat.farther.com/account-groups/v4/account-groups/${accountGroupId}`;
};
export default async function patchAccountGroupsV4(accountGroupId, body, idempotencyKey, config) {
    await axios.patch(url(accountGroupId), body, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            "Idempotency-key": idempotencyKey,
            // if we are changing the accounts we need to bust the cachedProxy (caches reqs that retrieve data from Black Diamond) bc the accountGroupId will not change but the underlying data will since the accounts have changed
            ...("virtualAccountIds" in body && {
                "cache-control": "delete-cache-client",
            }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
}
//# sourceMappingURL=patchAccountGroupsV4.js.map